"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _reactDom = _interopRequireDefault(require("react-dom"));

var _hooks = require("../../hooks");

var Portal = function Portal(_ref) {
  var children = _ref.children;
  var element = (0, _react.useRef)();
  (0, _hooks.useWillMount)(function () {
    element.current = document.createElement('div');
    document.body.appendChild(element.current);
  });
  (0, _react.useEffect)(function () {
    return function () {
      return document.body.removeChild(element.current);
    };
  }, []);
  return /*#__PURE__*/_reactDom["default"].createPortal(children, element.current);
};

Portal.propTypes = {
  children: _propTypes["default"].node
};
Portal.defaultProps = {
  children: null
};
var _default = Portal;
exports["default"] = _default;